class HorizontalSlider extends HTMLElement {
  sliderId = null;
  variantData = null;

  constructor() {
    super();

    this.variantData = this.querySelector('script[type="application/json"]')?.textContent;
    this.variantData = JSON.parse(this.variantData);

    window.addEventListener('DOMContentLoaded', () => {
      this.sliderId = this.dataset.sectionId;
      if (this.sliderId) {
        this.init();
      }

    });
  }

  init() {
    const swiperEl = document.getElementById('slider-' + this.sliderId);

    const swiperParams = {
      slidesPerView: this.variantData?.small_slides_in_view,
      spaceBetween: 20,
      loop: true,
      centeredSlides: true,
      freeMode: {
        enabled: true,
        sticky: true,
      },
      autoplay: true,
      breakpoints: {
        640: {
          slidesPerView: this.variantData?.medium_slides_in_view,
        },
        1024: {
          slidesPerView: this.variantData?.large_slides_in_view,
          freeMode: false,
        },
        1600: {
          slidesPerView: this.variantData?.xl_slides_in_view,
          freeMode: false,
        },
      },
      on: {
        init() {
          // ..
        },
      },
    };

    // now we need to assign all parameters to Swiper element
    Object.assign(swiperEl, swiperParams);

    // and now initialize it
    swiperEl.initialize();
  }
}
customElements.define('horizontal-slider', HorizontalSlider);
